/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "utils/navigation",
  "underscore",
  "moment",
  "utils/dom"
], function (
  Navigation,
  _,
  moment,
  dom
) {

  var AVAILABLE_FILTER_PREFIXES = Navigation.AVAILABLE_FILTER_PREFIXES;
  var QUERY_PARAMETERS_NAME = {
    QUERY: 'query',
    QUERY_: 'query_',
    QUERY_DATE_: 'query_date_',
    ORDER_BY: 'orderby',
    ORDER_DIRECTION: 'orderDir',
    SUMMARIZE_BY_PROPERTY: 'summarizeByProp',
    SUMMARIZE_BY_ORDER_BY: 'summarizeByOrder',
    DATA_SOURCES: 'datasources',
    SELECTED_TAB: 'tab'
  };
  var SEARCH_MODEL_PATHS = {
    // The `isParamsUpdateRequired:true` will override the summarize_by  with initial values
    // clearing search model will remove the summarize_by if set via data-[property-name] on initialization 
    //SUMMARIZE_BY: 'summarize_by',
    ORDER_BY: 'orderby',
    QUERY: 'user.query.and',
    ORDER_DIRECTION: 'order_direction',
    USER_CONSTRAINTS: 'user.constraints',
    VIEW: 'view',
    SOURCE_CONTEXT_FILTER_DATASOURCES: 'source_context.constraints.filter_datasources.filter_base',
    // The `isParamsUpdateRequired:true` will override the summarize_by  with initial values 
    //SUMMARIZE_BY_PROPERTY: 'summarize_by.property',
    //SUMMARIZE_BY_ORDER_BY: 'summarize_by.orderby',
    VIEW_NAME: 'view.name',
    USER_CONSTRAINTS_DATE: 'user.constraints.filter_mes:date',
    USER_CONSTRAINTS_DYNAMIC_FILTER: 'user.constraints.filter_', // dynamic filter prefix for userconstraints except date
  };

  var BaseQueryPameter = function (searchModelValue) {
    this.searchModelValue = searchModelValue;
    this.separator = Navigation.SEPARATOR || ",";
    this.path = '';
    this.queryParamName = '';
  }

  _.extend(BaseQueryPameter.prototype, {
    toQueryParam: function () {
      var value = null;
      if (this.searchModelValue) {
        value = this.addUrlParameter(
          _.map(this.searchModelValue.filter_base, function (filterValue) {
            return filterValue.id;
          })
        );
      }
      return {
        label: this.getQueryParamLabel(),
        value: value
      }
    },

    getQueryParamLabel: function () {
      return this.queryParamName;
    },

    addUrlParameter: function (filterValues) {
      return filterValues.join(this.separator);
    },

    setPath: function (path) {
      this.path = path;
    },

    fromQueryParam: function (parameterName, parameterValue) {
      var separatorRegex = new RegExp("\\s*\\" + this.separator + "\\s*");
      var value = _.map(parameterValue.split(separatorRegex), function (val) {
        return decodeURIComponent(val);
      });
      var cleanupFilterPrefixes = Object.values(AVAILABLE_FILTER_PREFIXES).join('|');
      this.label = parameterName.replace(new RegExp('^(' + cleanupFilterPrefixes + ')'), '');
      this.value = value;
    },

    getSeparator: function () {
      return this.separator;
    },

    getSearchModelAttrValue: function () {
      return this.value;
    },
    clearSearchModel: function (searchModel) {
      searchModel.set(this.path, undefined);
    },

    updateSearchModel: function (applicationModels) {
      var searchModel = applicationModels.search;
      var SearchModelItemValue = this.getSearchModelAttrValue(searchModel)
      searchModel.set(this.path, SearchModelItemValue);
    },
  });

  // All the item in search model except user.constraints
  var QueryPameter = function () { }
  _.extend(QueryPameter.prototype, BaseQueryPameter.prototype, {
    toQueryParam: function () {
      return {
        label: this.queryParamName,
        value: this.searchModelValue
      }
    },
    fromQueryParam: function (parameterName, parameterValue) {
      this.label = parameterName
      this.value = parameterValue;
    },

    updateSearchModel: function (applicationModels) {
      var searchModel = applicationModels.search;
      if (this.getSearchModelAttrValue()) {
        var queryParamValue = this.getSearchModelAttrValue()
        searchModel.set(this.path, queryParamValue);
      }
    }
  })

  var QueryParamOrderBy = function (constraint) {
    BaseQueryPameter.call(this, constraint);
    this.path = SEARCH_MODEL_PATHS.ORDER_BY;
    this.queryParamName = QUERY_PARAMETERS_NAME.ORDER_BY;
  }

  _.extend(QueryParamOrderBy.prototype, QueryPameter.prototype);

  var QueryParamSummarizeByProp = function (constraint) {
    BaseQueryPameter.call(this, constraint);
    this.path = SEARCH_MODEL_PATHS.SUMMARIZE_BY_PROPERTY;
    this.queryParamName = QUERY_PARAMETERS_NAME.SUMMARIZE_BY_PROPERTY;
  }

  _.extend(QueryParamSummarizeByProp.prototype, QueryPameter.prototype);

  var QueryParamSummarizeByOrder = function (constraint) {
    BaseQueryPameter.call(this, constraint);
    this.path = SEARCH_MODEL_PATHS.SUMMARIZE_BY_ORDER_BY;
    this.queryParamName = QUERY_PARAMETERS_NAME.SUMMARIZE_BY_ORDER_BY;
  }

  _.extend(QueryParamSummarizeByOrder.prototype, QueryPameter.prototype);

  var QueryParamOrderDirection = function (constraint) {
    BaseQueryPameter.call(this, constraint);
    this.path = SEARCH_MODEL_PATHS.ORDER_DIRECTION;
    this.queryParamName = QUERY_PARAMETERS_NAME.ORDER_DIRECTION;
  }

  _.extend(QueryParamOrderDirection.prototype, QueryPameter.prototype);

  var QueryParamSelectedTab = function (constraint) {
    BaseQueryPameter.call(this, constraint);
    this.path = SEARCH_MODEL_PATHS.VIEW_NAME;
    this.queryParamName = QUERY_PARAMETERS_NAME.SELECTED_TAB;
  }

  _.extend(QueryParamSelectedTab.prototype, QueryPameter.prototype, {

    updateSearchModel: function (applicationModels, changeView) {
      var searchModel = applicationModels.search;
      var selectedTabName = this.getSearchModelAttrValue();
      searchModel.set(this.path, selectedTabName);
      changeView({ name: selectedTabName });
    }
  });

  var QueryParamDatasources = function (constraint) {
    BaseQueryPameter.call(this, constraint);
    this.path = SEARCH_MODEL_PATHS.SOURCE_CONTEXT_FILTER_DATASOURCES;
    this.queryParamName = QUERY_PARAMETERS_NAME.DATA_SOURCES;
  }

  var QueryParamQuery = function (constraint) {
    BaseQueryPameter.call(this, constraint);
    this.path = '';
    this.queryParamName = QUERY_PARAMETERS_NAME.QUERY;
  }

  _.extend(QueryParamQuery.prototype, QueryPameter.prototype, {

    getQueryPrefix: function () {
      return this.prefix;
    },

    getQueryParamLabel: function () {
      return this.getQueryPrefix();
    },

    toQueryParam: function () {
      var value = null;
      if (this.searchModelValue) {
        value = this.searchModelValue.unparsed || this.searchModelValue.description;
      }
      return {
        label: this.getQueryParamLabel() + (this.searchModelValue.label || ''),
        value: value
      }
    },

    updateSearchModel: function (applicationModels) {
      var searchModel = applicationModels.search;
      var queryValue = this.getSearchModelAttrValue();
      if (queryValue && this.path) {
        searchModel.set(this.path, queryValue);
      }
    }

  });

  function InputUserQuery(query) {
    BaseQueryPameter.call(this, query);
    this.prefix = QUERY_PARAMETERS_NAME.QUERY;
  }

  _.extend(InputUserQuery.prototype, QueryParamQuery.prototype, {
    updateSearchModel: function (applicationModels, changeView, getUnparsedUserQueryPath) {
      var searchModel = applicationModels.search;
      var queryValue = this.getSearchModelAttrValue();
      if (queryValue) {
        searchModel.set(getUnparsedUserQueryPath().join("."), queryValue);
      }
    }
  })

  function RegularUserQuery(query) {
    BaseQueryPameter.call(this, query);
    this.prefix = QUERY_PARAMETERS_NAME.QUERY_
  }
  _.extend(RegularUserQuery.prototype, QueryParamQuery.prototype, {

    getSearchModelAttrValue: function () {
      var itemName = '';
      if (this.label.startsWith(this.prefix)) {
        itemName = this.label.replace(this.prefix, '');
        this.setPath(SEARCH_MODEL_PATHS.QUERY + "." + itemName);
      }

      var regular_user_query = {
        label: itemName,
        id: itemName,
        unparsed: ""
      };
      if (this.value.length) {
        regular_user_query.unparsed = this.value[0];
      }

      return regular_user_query;
    },
  })

  function DateUserQuery(query) {
    BaseQueryPameter.call(this, query);
    this.prefix = QUERY_PARAMETERS_NAME.QUERY_DATE_
  }

  _.extend(DateUserQuery.prototype, QueryParamQuery.prototype, {
    getSearchModelAttrValue: function () {
      var itemName = '';
      if (this.label.startsWith(this.prefix)) {
        itemName = this.label.replace(this.prefix, '');
        this.setPath(SEARCH_MODEL_PATHS.QUERY + "." + itemName)
      }
      var regular_user_query = {}
      if (this.value) {
        dom.updateDateInputUI(this.value, itemName);
        regular_user_query = this.createDynamicDateObject(this.value, itemName);
      }
      return regular_user_query;
    },

    createDynamicDateObject: function (dateRange, itemName) {
      var dateMatches = dateRange.match(/(\d{2}\.\d{2}\.\d{4})/g);
      var hasFrom = dateRange.indexOf('From') !== -1;
      var hasTo = dateRange.indexOf('To') !== -1;

      const resultObject = {
        label: itemName || "mes:date",
        and: [],
        description: dateRange,
        id: itemName || "mes:date"
      };

      if (dateMatches) {
        if (hasFrom) {
          var fromDateString = dateMatches[0];
          var fromDateParts = fromDateString.split('.');
          var fromDate = new Date(fromDateParts[2], fromDateParts[1] - 1, fromDateParts[0]);
          var fromTimestamp = fromDate.getTime();

          resultObject.and.push({
            num: fromTimestamp,
            cmp: "GE",
            unit: "ms_since_1970"
          });
        }

        if (hasTo && dateMatches.length > 1) {
          var toDateString = dateMatches[1];
          var toDateParts = toDateString.split('.');
          var toDate = new Date(toDateParts[2], toDateParts[1] - 1, toDateParts[0]);

          toDate.setHours(23, 59, 59, 999);
          var toTimestamp = toDate.getTime();

          resultObject.and.push({
            num: toTimestamp,
            cmp: "LE",
            unit: "ms_since_1970"
          });
        }
      }

      return resultObject;
    },
  })

  // All the item in user.constraints
  var BaseFilterQueryParam = function () { };
  _.extend(BaseFilterQueryParam.prototype, BaseQueryPameter.prototype, {
    getFitlerPrefix: function () { return '' },
    getQueryParamLabel: function () {
      return this.getFitlerPrefix() + this.searchModelValue.label;
    }
  })

  _.extend(QueryParamDatasources.prototype, BaseQueryPameter.prototype, {

    updateSearchModel: function (applicationModels) {
      var searchModel = applicationModels.search;
      var userSourceInfo = applicationModels.userSourceInfo;
      var dataSources = this.getSearchModelAttrValue();
      if (dataSources && userSourceInfo) {
        var userSources = userSourceInfo.get("sources.data_sources");
        var matchedSources = {};
        if (userSources) {
          dataSources = this.value.map(function (source) {
            return source.replace(/\+/g, ' ');
          });
          dataSources.forEach(function (urlSource) {
            var matchedSource = Object.values(userSources).find(function (userSource) {
              return userSource.query_expr.id === urlSource;
            });
            if (matchedSource) {
              matchedSources[matchedSource.name] = matchedSource.query_expr;
            }
          });
        }
        searchModel.input.set(this.path, matchedSources);
      }
    }
  });

  function DateFilter(constraint) {
    BaseQueryPameter.call(this, constraint);
  }

  _.extend(DateFilter.prototype, BaseFilterQueryParam.prototype, {
    getFitlerPrefix: function () {
      return AVAILABLE_FILTER_PREFIXES.DATE;
    },

    getSearchModelAttrValue: function () {
      var filterName = this.label;
      var filterQuery = "[data-name='" + filterName + "']";
      var filterLabel = 'Date';
      var filterNameWithPrefix = "filter_" + filterName
      this.setPath("user.constraints." + filterNameWithPrefix)
      var element = document.querySelector(filterQuery);
      if (element) {
        filterLabel = element.getAttribute("data-title") !== null
          ? element.getAttribute("data-title")
          : filterName;
      } else {
        filterLabel = filterName;
      }

      var DATE_FILTERS = _.map(this.value, function (element) {
        var filter_strings = element.split(".");
        return { "year": filter_strings[0], "month": filter_strings[1] };
      });
      var date_filter_structure = { label: filterName, filtered_name: filterLabel, filtered: {}, filter_base: {}, id: filterNameWithPrefix };
      var that = this;
      _.each(DATE_FILTERS, function (filterEntry) {
        if (filterEntry.month !== undefined) {
          var year_month = filterEntry.year + "." + filterEntry.month;
          date_filter_structure.filter_base[year_month] = that.createHierarchicalDateFilter(filterEntry.month, filterEntry.year, filterName);
        } else {
          _.each(that.value, function (filter_value) {
            date_filter_structure.filter_base[filter_value] = that.createNoneHierarchicalDateFilterYearEntry(filter_value, filterName);
          });
        }
      });
      return date_filter_structure;
    },

    getYearTimestamps: function (year) {
      var startOfYear = moment().year(year).startOf("year").unix() * 1000;
      var endOfYear = moment().year(year).endOf("year").unix() * 1000;
      return {
        startOfYear: startOfYear,
        endOfYear: endOfYear
      };
    },

    getMonthTimestamps: function (year, month) {
      var startOfMonth = moment().year(year).month(month).startOf("month").toDate().getTime();
      var endOfMonth = moment().year(year).month(month).endOf("month").toDate().getTime();
      return {
        startOfMonth: startOfMonth,
        endOfMonth: endOfMonth
      };
    },

    getTimestamps: function (year, month) {
      if (month) {
        return this.getMonthTimestamps(year, month);
      } else {
        return this.getYearTimestamps(year);
      }
    },

    createNoneHierarchicalDateFilterYearEntry: function (year, label) {
      var timestamps = this.getTimestamps(year);
      var startOfYear = timestamps.startOfYear;
      var endOfYear = timestamps.endOfYear;

      return {
        label: label,
        and: [
          {
            num: startOfYear,
            cmp: "GE",
            unit: "ms_since_1970"
          },
          {
            num: endOfYear,
            cmp: "LE",
            unit: "ms_since_1970"
          }
        ],
        description: year,
        id: year,
        value: {
          num: startOfYear,
          unit: "ms_since_1970"
        },
        path: []
      };
    },

    createHierarchicalDateFilter: function (month, year, label) {
      var timestamps = this.getTimestamps(year, month);
      var startOfMonth = timestamps.startOfMonth;
      var endOfMonth = timestamps.endOfMonth;
      var yearMonthLabel = year + "." + month;

      return {
        label: label,
        and: [
          {
            num: startOfMonth,
            cmp: "GE",
            unit: "ms_since_1970"
          },
          {
            num: endOfMonth,
            cmp: "LE",
            unit: "ms_since_1970"
          }
        ],
        description: month,
        id: yearMonthLabel,
        value: {
          num: startOfMonth,
          unit: "ms_since_1970"
        },
        path: [
          {
            label: label,
            and: [
              {
                num: startOfMonth,
                cmp: "GE",
                unit: "ms_since_1970"
              },
              {
                num: endOfMonth,
                cmp: "LE",
                unit: "ms_since_1970"
              }
            ],
            description: year,
            id: year,
            value: {
              num: startOfMonth,
              unit: "ms_since_1970"
            },
            path: []
          }
        ]
      };
    }
  });

  var RegularFilter = function (constraint) {
    BaseQueryPameter.call(this, constraint);
    this.path = '';
    this.queryParamName = 'filters';
  }

  _.extend(RegularFilter.prototype, BaseFilterQueryParam.prototype, {

    getFitlerPrefix: function () {
      return AVAILABLE_FILTER_PREFIXES.FILTER;
    },

    getSearchModelAttrValue: function () {
      this.setPath(SEARCH_MODEL_PATHS.USER_CONSTRAINTS_DYNAMIC_FILTER + this.label)
      var filterQuery = "[data-name='" + this.label + "']";
      var filterLabel = this.label;
      var filterElem = document.querySelector(filterQuery);
      if (filterElem && filterElem.getAttribute("data-title") != null) {
        filterLabel = filterElem.getAttribute("data-title");
      }
      var that = this;
      var intersectFilterStructure = { "label": "", "filtered_name": "", "filter_base": {} };
      intersectFilterStructure.label = this.label;
      intersectFilterStructure.filtered_name = filterLabel

      _.each(this.value, function (value) {
        intersectFilterStructure.filter_base[value] = {
          "label": that.label,
          "regex": "^\\Q" + value + "\\E$",
          "description": value,
          "id": value,
          "value": {
            "str": value
          }
        }
      });
      return intersectFilterStructure;
    }
  });

  function NestedFilter(constraint) {
    BaseQueryPameter.call(this, constraint);
  }

  _.extend(NestedFilter.prototype, BaseFilterQueryParam.prototype, {

    getFitlerPrefix: function () {
      return AVAILABLE_FILTER_PREFIXES.FILTER_NESTED;
    },
    getSearchModelAttrValue: function (searchModel) {
      var facets = _.filter(searchModel.submodel("facets").get(), function (facet) {
        return facet;
      }) || [];

      if (!facets || !facets.length) return
      var facetName = decodeURIComponent(this.label.replace(AVAILABLE_FILTER_PREFIXES.FILTER_NESTED, ""));
      var selectedFacet = _.find(facets, function (facet) {
        return facet.id === facetName;
      });
      if (selectedFacet) {
        var queryExpressions = [];

        _.each(this.value, function (group) {
          var filterParts = group.split('.');

          var matchingTopLevelEntry = _.find(selectedFacet.entries, function (entry) {
            return entry.value === filterParts[0];
          });

          if (filterParts.length === 1 && matchingTopLevelEntry) {
            queryExpressions.push(matchingTopLevelEntry.query_expr);
          }

          if (filterParts.length > 1 && matchingTopLevelEntry && matchingTopLevelEntry.entries) {
            var nestedEntry = _.find(matchingTopLevelEntry.entries, function (entry) {
              return entry.value === filterParts[1];
            });
            if (nestedEntry) {
              queryExpressions.push(nestedEntry.query_expr);
            }
          }
        });

        if (queryExpressions.length > 0) {
          var intersectFilterStructure = { "label": "", "filtered_name": "", "filter_base": {} };
          intersectFilterStructure.label = facetName
          intersectFilterStructure.id = AVAILABLE_FILTER_PREFIXES.FILTER + facetName;
          intersectFilterStructure.filtered_name = facetName
          var filter_base = {};
          queryExpressions.forEach(function (filter) {
            filter_base[filter.id] = filter
          })
          intersectFilterStructure.filter_base = filter_base;
        }

        var existingConstraints = searchModel.get(SEARCH_MODEL_PATHS.USER_CONSTRAINTS) || {};
        existingConstraints[AVAILABLE_FILTER_PREFIXES.FILTER + facetName] = intersectFilterStructure;
        searchModel.set(SEARCH_MODEL_PATHS.USER_CONSTRAINTS, existingConstraints);
      }
    }
  });

  function ValueFilter(constraint) {
    BaseQueryPameter.call(this, constraint);
  }

  _.extend(ValueFilter.prototype, BaseFilterQueryParam.prototype, {
    getFitlerPrefix: function () {
      return AVAILABLE_FILTER_PREFIXES.VALUE;
    },
    getSearchModelAttrValue: function (searchModel) {
      var filterName = decodeURIComponent(this.value.replace(AVAILABLE_FILTER_PREFIXES.VALUE, ""));
      searchModel.setSelectedFacetValues(filterName, this.value, filterName);
      searchModel.set(SEARCH_MODEL_PATHS.USER_CONSTRAINTS_DYNAMIC_FILTER + filterName + ".noFilter", true);
    }
  });

  function createQueryParamFromUrlParamFactory(queryParamValue, queryParamName) {
    var obj;
    if (queryParamName == QUERY_PARAMETERS_NAME.ORDER_BY) {
      obj = new QueryParamOrderBy();
    } else if (queryParamName == QUERY_PARAMETERS_NAME.SUMMARIZE_BY_PROPERTY) {
      obj = new QueryParamSummarizeByProp();
    } else if (queryParamName == QUERY_PARAMETERS_NAME.SUMMARIZE_BY_ORDER_BY) {
      obj = new QueryParamSummarizeByOrder();
    } else if (queryParamName == QUERY_PARAMETERS_NAME.ORDER_DIRECTION) {
      obj = new QueryParamOrderDirection();
    } else if (queryParamName == QUERY_PARAMETERS_NAME.SELECTED_TAB) {
      obj = new QueryParamSelectedTab();
    } else if (queryParamName.startsWith(AVAILABLE_FILTER_PREFIXES.FILTER_NESTED)) {
      obj = new NestedFilter();
    } else if (queryParamName.startsWith(AVAILABLE_FILTER_PREFIXES.FILTER)) {
      obj = new RegularFilter();
    } else if (queryParamName.startsWith(AVAILABLE_FILTER_PREFIXES.DATE)) {
      obj = new DateFilter();
    } else if (queryParamName.startsWith(AVAILABLE_FILTER_PREFIXES.VALUE)) {
      obj = new ValueFilter();
    } else if (queryParamName === QUERY_PARAMETERS_NAME.DATA_SOURCES) {
      obj = new QueryParamDatasources();
    } else if (queryParamName == QUERY_PARAMETERS_NAME.QUERY) {
      obj = new InputUserQuery();
    } else if (queryParamName.startsWith(QUERY_PARAMETERS_NAME.QUERY_DATE_)) {
      obj = new DateUserQuery();
    } else if (queryParamName.startsWith(QUERY_PARAMETERS_NAME.QUERY_)) {
      obj = new RegularUserQuery();
    }

    if (obj) {
      obj.fromQueryParam(queryParamName, queryParamValue);
    }
    return obj;
  }

  function createQueryParamFilterFactory(constraint) {
    var hasAndUnit = function () {
      var base = constraint.filter_base[Object.keys(constraint.filter_base)[0]];
      return base && base.and && base.and.length > 0 && base.and[0].hasOwnProperty("unit") && base.and[0].unit === "ms_since_1970";
    };

    var hasDefinedLabel = function () {
      var base = constraint.filter_base[Object.keys(constraint.filter_base)[0]];
      return base && base.label !== undefined;
    };

    var hasFilterBase = function (filter) {
      return filter.filter_base && Object.keys(filter.filter_base).length > 0;
    };

    var hasLabelWithAtSymbol = function () {
      var base = constraint.filter_base[Object.keys(constraint.filter_base)[0]];
      return base && base.label !== undefined && base.label.indexOf("@") !== -1;
    };

    if (constraint.noFilter) {
      return new ValueFilter(constraint);
    } else if (hasFilterBase(constraint) && hasAndUnit()) {
      return new DateFilter(constraint);
    } else if (hasFilterBase(constraint) && hasLabelWithAtSymbol()) {
      return new NestedFilter(constraint);
    } else if (hasFilterBase(constraint) && hasDefinedLabel() && !hasAndUnit() && !hasLabelWithAtSymbol()) {
      return new RegularFilter(constraint);
    }
  }


  function createQueryParamFactory(searchModelValue, type) {
    switch (type) {
      case QUERY_PARAMETERS_NAME.QUERY:
        return new QueryParamQuery(searchModelValue);
      case QUERY_PARAMETERS_NAME.ORDER_BY:
        return new QueryParamOrderBy(searchModelValue);
      case QUERY_PARAMETERS_NAME.ORDER_DIRECTION:
        return new QueryParamOrderDirection(searchModelValue);
      case QUERY_PARAMETERS_NAME.SUMMARIZE_BY_PROPERTY:
        return new QueryParamSummarizeByProp(searchModelValue);
      case QUERY_PARAMETERS_NAME.SUMMARIZE_BY_ORDER_BY:
        return new QueryParamSummarizeByOrder(searchModelValue);
      case QUERY_PARAMETERS_NAME.DATA_SOURCES:
        return new QueryParamDatasources(searchModelValue);
      case QUERY_PARAMETERS_NAME.SELECTED_TAB:
        return new QueryParamSelectedTab(searchModelValue);
      default:
        return;
    }
  }

  function createUserQueryFactory(query, key) {
    var hasAndUnit = function () {
      return query.and && query.and.length > 0 && query.and[0].hasOwnProperty("unit") && query.and[0].unit === "ms_since_1970";
    };

    if (key === QUERY_PARAMETERS_NAME.QUERY) {
      return new InputUserQuery(query);
    } else if (query.unparsed) {
      return new RegularUserQuery(query);
    } else if (hasAndUnit()) {
      return new DateUserQuery(query);
    }
  }

  function clearSearchModel(searchModel, changeView) {
    Object.values(SEARCH_MODEL_PATHS).forEach(function (path) {
      searchModel.unset(path);
    });
    changeView({ name: '' });
  }

  
  return {
    updateUrlParametersFromSearchModel: function (applicationModels) {
      var queryParameterList = [];
      var sourceContext = null;
      var searchModel = applicationModels.search;
      var sourceContextData = searchModel.input.get('source_context');
      if (sourceContextData && sourceContextData.constraints && sourceContextData.constraints.view) {
        sourceContext = sourceContextData.constraints.view.name;
      }
      var userQueries = searchModel.input.get(SEARCH_MODEL_PATHS.QUERY);
      _.forEach(userQueries, function (userQuery, key) {
        queryParameterList.push(createUserQueryFactory(userQuery, key));
      })
      queryParameterList.push(createQueryParamFactory(sourceContext, QUERY_PARAMETERS_NAME.SELECTED_TAB));

      var userConstraints = searchModel.input.get('user.constraints') || [];
      Object.keys(userConstraints).forEach(function (constraint) {
        queryParameterList.push(createQueryParamFilterFactory(userConstraints[constraint]));
      });
      queryParameterList.push(createQueryParamFactory(searchModel.input.get('orderby'), QUERY_PARAMETERS_NAME.ORDER_BY));
      queryParameterList.push(createQueryParamFactory(searchModel.input.get('order_direction'), QUERY_PARAMETERS_NAME.ORDER_DIRECTION));

      var summarizeBy = searchModel.input.get('summarize_by');
      if (summarizeBy) {
        queryParameterList.push(createQueryParamFactory(summarizeBy.orderby, QUERY_PARAMETERS_NAME.SUMMARIZE_BY_ORDER_BY));
        queryParameterList.push(createQueryParamFactory(summarizeBy.property, QUERY_PARAMETERS_NAME.SUMMARIZE_BY_PROPERTY));
      }
      if (sourceContextData && sourceContextData.constraints && sourceContextData.constraints.filter_datasources) {
        var filterBase = sourceContextData.constraints.filter_datasources || {};
        queryParameterList.push(createQueryParamFactory(filterBase, QUERY_PARAMETERS_NAME.DATA_SOURCES));
      }
      queryParameterList = _.filter(queryParameterList, function (queryParamItem) { return !!queryParamItem })
      var params = queryParameterList.map(function (queryParam) {
        return queryParam.toQueryParam();
      });
      
      if (!Navigation.URLParams.isSameAsCurrent(params)) {
        var replaceFlag = !Navigation.URLParams.initialSyncDone;
        Navigation.URLParams.setUrlParams(params , false, { replace: replaceFlag });
        Navigation.URLParams.initialSyncDone = true;
      }
    },

    syncSearchModelWithUrlHistory: function (applicationModels, getUnparsedUserQueryPath, resetSearch, changeView, setUpdatingState) {
      if (!applicationModels.search) {
        return;
      }
      applicationModels.search.deactivate();
      clearSearchModel(applicationModels.search, changeView);
      var urlParametersObject = Navigation.URLParams.getAll();
      if (!urlParametersObject[QUERY_PARAMETERS_NAME.QUERY]) {
        resetSearch();
      }
      _.forEach(urlParametersObject, function (parameterValue, parameterName) {
        var queryParam = createQueryParamFromUrlParamFactory(parameterValue, parameterName, applicationModels.search);
        if (queryParam) {
          queryParam.updateSearchModel(applicationModels, changeView, getUnparsedUserQueryPath, resetSearch);
        }
      });
      applicationModels.search.activate();
      dom.updateSummerizedUI(applicationModels.search);
    }
  }
})


